import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import LoaderOverly from '../components/loader';
import AboutUs from '../pages/about-us';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

// Import kategori menu foods
import MenuPaket from '../pages/Menu-page/foods/menu_paket/Index';
import MenuSpecial from '../pages/Menu-page/foods/menu_special/index';
import MenuPorsi from '../pages/Menu-page/foods/menu_porsi/index';
import NasiGoreng from '../pages/Menu-page/foods/nasi_goreng/index';
import Sayur from '../pages/Menu-page/foods/Sayur/index';
import AddOn from '../pages/Menu-page/foods/Add-on/index';
import Snack from "../pages/Menu-page/foods/Snack/index"
import MieGoreng from "../pages/Menu-page/foods/mie_goreng/index"
import Kwetiau from "../pages/Menu-page/foods/kwetiau/index"
import Bihun from "../pages/Menu-page/foods/bihun/index"

//import kategori drink
import IceBlended from "../pages/Menu-page/drink/ice_blended/index"
import Special from "../pages/Menu-page/drink/special_drink/index"
import CoffeTea from "../pages/Menu-page/drink/coffe_tea/index"
import Juice from "../pages/Menu-page/drink/juice/index"
import OtherDrink from "../pages/Menu-page/drink/other_drink/index"
import KategoriDrink from "../pages/Menu-page/drink"

// Import komponen Kategori
import Kategori from "../pages/Menu-page/Kategori";

// Lazy load untuk halaman utama
const Locations = React.lazy(() => import('../pages/locations'));
const Home = React.lazy(() => import('../pages/home'));
const Menu = React.lazy(() => import('../pages/Menu-page/index'));
const Drink = React.lazy(() => import('../pages/Menu-page/drink'));

const RouteApp = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {isLoading ? (
        <LoaderOverly />
      ) : (
        <Suspense fallback={<LoaderOverly />}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/location/:latitude/:longitude' element={<Locations />} />
            <Route path='/about' element={<WithLayout><AboutUs /></WithLayout>} />
            <Route path='/menu' element={<WithLayout><Menu /></WithLayout>} />
            <Route path='/drink' element={<DrinkLayout><Drink /></DrinkLayout>} />

            {/* Routing halaman kategori menu dengan komponen Kategori foods */}
            <Route path='/menu/paket' element={<KategoriLayout><MenuPaket /></KategoriLayout>} />
            <Route path='/menu/special' element={<KategoriLayout><MenuSpecial /></KategoriLayout>} />
            <Route path='/menu/porsi' element={<KategoriLayout><MenuPorsi /></KategoriLayout>} />
            <Route path='/menu/nasi-goreng' element={<KategoriLayout><NasiGoreng/></KategoriLayout>} />
            <Route path='/menu/mie-goreng' element={<KategoriLayout><MieGoreng /></KategoriLayout>} />
            <Route path='/menu/kwetiau' element={<KategoriLayout><Kwetiau /></KategoriLayout>} />
            <Route path='/menu/bihun' element={<KategoriLayout><Bihun /></KategoriLayout>} />
            <Route path='/menu/sayur' element={<KategoriLayout><Sayur /></KategoriLayout>} />
            <Route path='/menu/addon' element={<KategoriLayout><AddOn /></KategoriLayout>} />
            <Route path='/menu/snack' element={<KategoriLayout><Snack /></KategoriLayout>} />

            {/* Routing halaman kategori menu dengan komponen Kategori drink */}
             <Route path='/drink/ice-blended' element={<DrinkLayout><IceBlended /></DrinkLayout>} />
            <Route path='/drink/special-drink' element={<DrinkLayout><Special /></DrinkLayout>} />
            <Route path='/drink/coffe-tea' element={<DrinkLayout><CoffeTea /></DrinkLayout>} />
            <Route path='/drink/juice' element={<DrinkLayout><Juice /></DrinkLayout>} />
            <Route path='/drink/other-drink' element={<DrinkLayout><OtherDrink /></DrinkLayout>} />
          </Routes>
        </Suspense>
      )}
    </>
  );

  // Komponen layout umum (tanpa kategori)
  function WithLayout({ children }) {
    return (
      <div className="App">
        <Navbar />
        {children}
        <Footer />
      </div>
    );
  }
  // Komponen layout umum (tanpa kategori)
  function DrinkLayout({ children }) {
    return (
      <div className="App">
        <Navbar />
        {children}
        <Footer />
      </div>
    );
  }

  // Komponen layout khusus kategori (dengan komponen tombol kategori)
  function KategoriLayout({ children }) {
    return (
      <div className="App">
        <Navbar />
        {/* <Kategori /> */}
        {children}
        <Footer />
      </div>
    );
  }
};

export default RouteApp;
